import React from 'react';
import './PrivacyFoundation.css';

export default function PrivacyFoundation() {
  return (
    <section className="privacy-foundation landing__section" aria-labelledby="privacy-heading">
      <div className="landing__column landing__column--narrow">
        <div className="fade-up">
          <h2 className="privacy-foundation__heading" id="privacy-heading">
            The foundation is privacy.
          </h2>
          <p className="privacy-foundation__body">
            Your data is encrypted on your device with a key only you have.
            It leaves your device already encrypted, and we can't read any of it —
            not the values you wrote, not the goals you're working toward,
            not the entries in your journal.
          </p>
          <p className="privacy-foundation__position">
            We designed it this way because a tool for your inner life should
            not be something another company reads.
          </p>
        </div>
      </div>
    </section>
  );
}
